import axios from 'axios'

//URL base dell'API per i sondaggi, recuperato dall'env file
const SONDAGGI_REST_API_URL = process.env.REACT_APP_API_PREFIX + 'sondaggio'

const headers = { 'Content-Type': 'application/json' }

class SondaggiService{

     /**
     * Recupera tutti i sondaggi disponibili nel sistema.
     * Effettua una richiesta GET a `/sondaggio/all`.
     *
     * @returns {Promise} - Una promessa che restituisce la lista di tutti i sondaggi.
     */
     getAll() {
        return axios.get(SONDAGGI_REST_API_URL + "/all")
    }

    /**
     * Recupera tutti i sondaggi associati a un determinato comune.
     * Effettua una richiesta GET a `/sondaggio/comune/{comId}`.
     *
     * @param {number} comId - L'ID del comune per cui recuperare i sondaggi.
     * @returns {Promise} - Una promessa che restituisce la lista dei sondaggi del comune specificato.
     */
    getAllByComune(comId) {
        return axios.get(SONDAGGI_REST_API_URL + `/comune/${comId}`)
    }

    /**
     * Salva o aggiorna un sondaggio nel sistema.
     * Effettua una richiesta POST a `/sondaggio/save` con i dati del sondaggio.
     *
     * @param {Object} sondaggio - Oggetto contenente i dettagli del sondaggio da salvare.
     * @returns {Promise} - Una promessa che restituisce la risposta del server dopo il salvataggio.
     */
    saveSondaggio(sondaggio) {
        return axios.post(SONDAGGI_REST_API_URL + "/save", sondaggio, headers)
    }

     /**
     * Recupera un sondaggio specifico in base al suo ID.
     * Effettua una richiesta GET a `/sondaggio/{sonId}`.
     *
     * @param {number} sonId - L'ID del sondaggio da recuperare.
     * @returns {Promise} - Una promessa che restituisce i dettagli del sondaggio.
     */
     getSondaggioById(sonId) {
        return axios.get(SONDAGGI_REST_API_URL + `/${sonId}`)
    }

    salvaCompleto(formData) {
        return axios.post(
            `${SONDAGGI_REST_API_URL}/salva-completo`,
            formData,
            headers
        );
    }
    
    


}

// Creazione dell'istanza per essere importata direttamente nei componenti
const sondaggioServiceInstance = new SondaggiService()
export default sondaggioServiceInstance;